<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label">
          {{ $t('examschedule.mainProgram') }}
          <span class="text-danger">*</span>
        </label>
        <ts-loading-banner :loading="loadingPreData">
          <ts-search-select
            :disabled="editing"
            v-model.number="model.acp_id"
            @change="getSubProgram(model.acp_id)"
            :options="mainProgramOptions"
            @input="model.acps_id = []"
          ></ts-search-select>
        </ts-loading-banner>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('acp_id') }}
        </div>
      </div>
      <div class="form-group">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <label class="control-label mb-0">
            {{ $t('examschedule.subProgram') }}
            <span class="text-danger">*</span>
            <i
              v-if="sub_programs.length == 0 && model.acp_id !== ''"
              class="fas fa-spinner fa-pulse label-loading"
            ></i>
          </label>
          <div
            v-if="!editing && sub_programs.length > 0"
            class="btn-group btn-group-sm"
          >
            <a
              href="#"
              class="text-primary mr-2"
              @click.prevent="selectAllSubPrograms"
            >
              <small>{{ $t('selectAll') || 'Select All' }}</small>
            </a>
            <a href="#" class="text-muted" @click.prevent="model.acps_id = []">
              <small>{{ $t('clearAll') || $t('clear') || 'Clear All' }}</small>
            </a>
          </div>
        </div>
        <a-select
          v-model="model.acps_id"
          mode="multiple"
          showSearch
          allowClear
          style="width: 100%"
          :placeholder="$t('all') || 'All'"
          :disabled="editing || sub_programs.length == 0"
          :options="subProgramOptions"
          optionFilterProp="label"
          :maxTagCount="2"
          :filterOption="
            (input, option) =>
              (option.componentOptions &&
              option.componentOptions.children &&
              option.componentOptions.children[0]
                ? option.componentOptions.children[0].text
                : option.data.attrs.label || ''
              )
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
        />
        <div style="color:#cc4946;margin:4px 0 0" v-if="errors.has('acps_id')">
          {{ errors.first('acps_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('examschedule.name') }} <span class="text-danger">*</span>
        </label>
        <input
          ref="exam_name"
          v-model="model.exam_name"
          type="text"
          class="form-control kh-font"
          :class="{ 'is-invalid': errors.has('exam_name') }"
          placeholder="Enter exam name"
        />
        <div class="invalid-feedback" v-if="errors.has('exam_name')">
          {{ errors.first('exam_name') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('examschedule.startDate') }} <span class="text-danger">*</span>
        </label>
        <ts-date-picker-input v-model="model.start_date" />
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('start_date') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{
            $t('examschedule.endDate') ||
              $t('examschedule.enddate') ||
              'End Date'
          }}
          <span class="text-danger">*</span>
        </label>
        <ts-date-picker-input v-model="model.end_date" />
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('end_date') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"> {{ $t('examschedule.criteria') }} </label>
        <textarea
          v-model="model.exam_criteria"
          rows="3"
          class="form-control"
          :class="{ 'is-invalid': errors.has('exam_criteria') }"
          placeholder="Enter exam criteria"
        ></textarea>
        <div class="invalid-feedback" v-if="errors.has('exam_criteria')">
          {{ errors.first('exam_criteria') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  name: 'exam-chedule-create-form',
  props: ['edit', 'leave'],
  data() {
    return {
      model: {
        acp_id: '',
        acps_id: [],
        exam_name: '',
        start_date: moment().format('DD-MM-YYYY'),
        end_date: moment().format('DD-MM-YYYY'),
        exam_criteria: ''
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false,
      editing: false
    }
  },
  created() {
    if (this.isStaff) {
      this.fetchResourceBeforeCreate()
    }
  },
  computed: {
    ...mapState('examSchedule', ['sub_programs']),
    mainProgramOptions() {
      return this.$store.state.examSchedule.main_programs.map(el => ({
        value: el.acp_id,
        text: el.acp_name_foreign
      }))
    },
    subProgramOptions() {
      return this.sub_programs.map(el => ({
        value: el.acps_id,
        label: el.acps_name_foreign
      }))
    },
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  methods: {
    fetchResourceBeforeCreate() {
      this.loadingPreData = true
      this.$store
        .dispatch('examSchedule/dataBeforeCreate')
        .then(() => {
          this.loadingPreData = false
          this.setEdit()
        })
        .catch(error => {
          this.loadingPreData = false
          this.$toasted.error(error.message)
        })
    },
    ...mapActions('examSchedule', ['getSubProgram']),

    selectAllSubPrograms() {
      this.model.acps_id = this.sub_programs.map(el => el.acps_id)
    },

    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'exam-schedule' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let payload = { ...this.model }
        if (
          (!payload.acps_id || payload.acps_id.length === 0) &&
          this.sub_programs.length > 0
        ) {
          payload.acps_id = this.sub_programs.map(el => el.acps_id)
        }
        let response = await this.$store.dispatch(
          'examSchedule/create',
          payload
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        const payload = {
          ...this.model,
          acps_id: Array.isArray(this.model.acps_id)
            ? this.model.acps_id[0]
            : this.model.acps_id
        }
        let response = await this.$store.dispatch(
          'examSchedule/update',
          payload
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'exam-schedule' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      if (this.model.acps_id && !Array.isArray(this.model.acps_id)) {
        this.model.acps_id = [this.model.acps_id]
      }
      this.editing = true
    },

    clearForm() {
      this.model.acp_id = ''
      this.model.acps_id = []
      this.model.exam_name = ''
      this.model.start_date = moment().format('DD-MM-YYYY')
      this.model.end_date = moment().format('DD-MM-YYYY')
      this.model.exam_criteria = ''
    }
  },
  watch: {
    'model.acp_id': function(value) {
      if (value) {
        this.getSubProgram(value)
      }
    },
    leave: {
      handler() {
        if (this.leave) {
          this.clearForm()
          this.editing = false
        }
      }
    },
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
